import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../store/hook";
import { useEffect, useRef, useState } from "react";
import { Constant } from "../../../constants/constant";
import { showAndHideSpinner } from "../../../reducers/spinnerSlice";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import Dcs0301Form from "./form/Dcs0301Form.";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import AppPagination from "../../../components/commons/AppPagination";
import Dcs0301Service from "../../../services/dcs/Dcs0301Service";
import ViewActiveStatus from "../../../components/commons/ViewActiveStatus";
import { VariablesConstant } from "../../../constants/variables";
import Dcs0301Detail from "./detail/Dcs0301Detail";
import AppDialog from "../../../components/commons/AppDialog";
import AddVersionForm from "./components/AddVersionForm";
import AddProtocolForm from "./components/AddProtocolForm";

export class Dcs0301Search {
  protNm?: any;
  status?: any;
  page: number;
  size: number;
  time: any;
  constructor(protNm: any, status: any, page: number, size: number, time: any) {
    this.protNm = protNm;
    this.status = status;
    this.page = page;
    this.size = size;
    this.time = time;
  }
}

export class VersionSearch {
  protId?: any;
  page: number;
  size: number;
  time: any;
  constructor(protId: any, page: number, size: number, time: any) {
    this.protId = protId;
    this.page = page;
    this.size = size;
    this.time = time;
  }
}

export default function Dcs0301() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [modelSearch, setModelSearch] = useState<Dcs0301Search>(new Dcs0301Search("", "", 0, Constant.ROWS_OF_PAGE, new Date().getTime()));
  const [versionSearch, setVersionSearch] = useState<VersionSearch>(new VersionSearch("", 0, Constant.ROWS_OF_PAGE, new Date().getTime()));

  const lang = useAppSelector((state: any) => state.language.lang);
  const totalPage = useRef(1);
  const totalVersionPage = useRef(1);

  const [listProtocol, setListProtocol] = useState<any>([]);
  const [listVersion, setListVersion] = useState<any>([]);
  const [protocolSlt, setProtocolSlt] = useState<any>({});
  const [data, setData] = useState<any>();

  const [viewLstProtocol, setViewLstProtocol] = useState<any>(true);
  const [openForm, setOpenForm] = useState<any>(false);
  const [openDialog, setOpenDialog] = useState<any>(false);
  const [formStatus, setFormStatus] = useState<string>();

  useEffect(() => {
    _getList();
  }, [modelSearch.status, modelSearch.page, modelSearch.size, modelSearch.time]);

  useEffect(() => {
    if (Object.keys(protocolSlt).length !== 0) {
      _getListVersion();
    }
  }, [versionSearch.protId, versionSearch.page, modelSearch.size, modelSearch.time]);

  useEffect(() => {
    if (Object.keys(protocolSlt).length !== 0) {
      setVersionSearch({
        ...versionSearch,
        protId: protocolSlt.id,
        page: 0,
        time: new Date().getTime(),
      });
    }
  }, [protocolSlt]);

  const reset = () => {
    setModelSearch({
      ...new Dcs0301Search("", "", 0, Constant.ROWS_OF_PAGE, new Date().getTime()),
    });
  };

  const handleChangeProtocolNm = (event: any) => {
    setModelSearch({
      ...modelSearch,
      protNm: event.target.value,
    });
  };

  const search = () => {
    setModelSearch({
      ...modelSearch,
      page: 0,
      time: new Date().getTime(),
    });
  };

  function _getList() {
    dispatch(showAndHideSpinner(true));
    Dcs0301Service.getInstance()
      .getList(modelSearch)
      .then((res: any) => {
        setListProtocol(res.data.responseData.data);
        totalPage.current = res.data.responseData.totalElement;
        if (protocolSlt.id) {
          setProtocolSlt(res.data.responseData.data.find((item: any) => item.id === protocolSlt.id) ? res.data.responseData.data.find((item: any) => item.id === protocolSlt.id) : {});
        }
        dispatch(showAndHideSpinner(false));
      })
      .catch((err: any) => {});
  }

  function _getListVersion() {
    dispatch(showAndHideSpinner(true));
    Dcs0301Service.getInstance()
      .getVersionByProtId(versionSearch)
      .then((res: any) => {
        setListVersion(res.data.responseData.data);
        totalVersionPage.current = res.data.responseData.totalElement;
        dispatch(showAndHideSpinner(false));
      })
      .catch((err: any) => {});
  }

  const changePage = (page: number) => {
    setModelSearch({
      ...modelSearch,
      page: page,
    });
  };

  const handleSelectProtocol = (data: any) => {
    setProtocolSlt(data);
  };

  const handleChangeRowOfPage = (value: any) => {
    setModelSearch({
      ...modelSearch,
      size: value,
    });
  };

  const handleAdd = () => {
    setData({
      isCreate: true,
    });
    setOpenForm(true);
  };

  const editProtocol = (data: any) => {
    setData({
      isCreate: false,
      protId: data.id,
    });
    setOpenForm(true);
  };

  // const deleteProtocol = (data: any) => {
  //   Swal.fire({
  //     title: t("dcs0201.message.dialog.confirmDelete"),
  //     showCancelButton: true,
  //     confirmButtonText: t("dcs0201.btn.delete"),
  //     cancelButtonText: t("dcs0201.btn.cancel"),
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       dispatch(showAndHideSpinner(true));
  //       Dcs0301Service.getInstance()
  //         .delete(data)
  //         .then((result) => {
  //           dispatch(showAndHideSpinner(false));
  //           if (result.data.status) {
  //             toast.success(t("dcs0301.message.success.delete"));
  //             _getList();
  //             _getListVersion();
  //           } else {
  //             toast.error(t("dcs0301.message.err.delete"));
  //           }
  //         });
  //     }
  //   });
  // };

  const addVersion = () => {
    setOpenDialog(true);
    setData({ protocol: protocolSlt, isCreate: true });
    setFormStatus("C");
  };

  const editVersion = (data: any) => {
    setOpenDialog(true);
    setData({ protocol: protocolSlt, version: data, isCreate: false, data: data });
    setFormStatus("U");
  };

  const deleteVersion = (data: any) => {
    Swal.fire({
      title: t("dcs0201.message.dialog.confirmDelete"),
      showCancelButton: true,
      confirmButtonText: t("dcs0201.btn.delete"),
      cancelButtonText: t("dcs0201.btn.cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(showAndHideSpinner(true));
        Dcs0301Service.getInstance()
          .deleteVersion(data.id)
          .then((result) => {
            dispatch(showAndHideSpinner(false));
            if (result.data.status) {
              toast.success(t("dcs0301.message.success.deleteVersion"));
              _getListVersion();
            } else {
              toast.error(t("dcs0301.message.err.deleteVersion"));
            }
          });
      }
    });
  };

  const closeDialog = (data: any) => {
    setOpenDialog(false);
    if (data) {
      _getListVersion();
    }
  };

  const closeForm = (data: any) => {
    setOpenForm(false);
    if (data) {
      _getList();
    }
  };

  return (
    <>
      <ToastContainer></ToastContainer>
      <AppDialog
        className="width-dialog"
        open={openDialog}
        style={{ width: "800px" }}
        onClose={closeDialog}
        title={formStatus === "C" ? `${t("dcs0301.title.dialog.addVersion")}` : `${t("dcs0301.title.dialog.editVersion")}`}>
        <AddVersionForm onClose={closeDialog} data={data} />
      </AppDialog>

      <AppDialog
        className="width-dialog"
        open={openForm}
        style={{ width: "800px" }}
        onClose={closeForm}
        title={data?.isCreate ? `${t("dcs0301.title.dialog.addProtocol")}` : `${t("dcs0301.title.dialog.editProtocol")}`}>
        <AddProtocolForm onClose={closeForm} data={data} />
      </AppDialog>
      {viewLstProtocol && (
        <>
          <div className="box">
            <div className="search-body">
              <div className="d-flex gap-2 align-items-center">
                {/* <div className="search-el">
                  <label className="search-label"> {t("dcs0301.label.status")}</label>
                  <Dropdown
                    value={modelSearch.status}
                    onChange={(e: any) => setModelSearch({ ...modelSearch, status: e.value })}
                    options={status}
                    placeholder="All"
                    optionLabel={Constant.SOUTH_KOREA === lang ? Constant.LABEL_KR : Constant.LABEL_EN}
                  />
                </div> */}
                <div className="search-el input-search">
                  <label className="search-label"> {t("dcs0301.label.protNm")}</label>
                  <input
                    value={modelSearch.protNm || ""}
                    className={`form-control`}
                    name="dataMapNm"
                    placeholder={`${t("dcs0301.label.protNm")}`}
                    onChange={handleChangeProtocolNm}
                    onKeyUp={(e: any) => {
                      if (e.key === "Enter") search();
                    }}
                  />
                </div>
                <button type="button" className="custom-btn gradient" onClick={search}>
                  <i className="pi pi-search me-2"></i> {t("sys0301.label.search")}
                </button>
                <button type="button" className="custom-btn" onClick={reset}>
                  <i className="pi pi-refresh me-2"></i> {t("sys0301.label.reset")}
                </button>
              </div>
            </div>
          </div>
          <div className="box">
            <div className="box-body" style={{minHeight: "735px"}}>
              {/* <div className="d-flex justify-content-between mb-3">
                <div className="box-title">
                  <h3 className="mb-sm-0 mb-0 flex-grow-1">{t("dcs0301.title.page")}</h3>
                </div>
                <div className="button-head-body d-flex gap-2">
                  <Dropdown
                    value={modelSearch.size}
                    onChange={(e: any) => handleChangeRowOfPage(e.value)}
                    options={Constant.LST_ROW_OF_PAGE}
                    optionLabel={Constant.SOUTH_KOREA === lang ? Constant.LABEL_KR : Constant.LABEL_EN}
                    style={{ minWidth: "100px" }}
                  />
                  <button type="button" className="custom-btn gradient" onClick={handleAdd}>
                    <i className="pi pi-plus me-2"></i> {t("sample.label.button.add")}
                  </button>
                </div>
              </div> */}
              <div className="row">
                <div className="col-md-3">
                  {/* <div className="tbl-st tbl-scroll-500 scroll-x">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">{t("dcs0301.table.header.no")}</th>
                          <th scope="col">{t("dcs0301.table.header.protNm")}</th>
                          <th scope="col">{t("dcs0301.table.header.createdDate")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listProtocol.map((element: any, index: number) => (
                          <tr key={element.id} className={protocolSlt.id === element.id ? "cus-cursor selected-row" : "cus-cursor"} onClick={() => handleSelectProtocol(element)}>
                            <td>{totalPage.current - (modelSearch.page - 1 < 0 ? 0 : modelSearch.page - 1) * modelSearch.size - index}</td>
                            <td>{element.protNm}</td>
                            <td>{moment(element.createdDt).format("MM/DD/YYYY")}</td>
                          </tr>
                        ))}
                        {listProtocol.length === 0 && (
                          <tr className="text-center">
                            <td colSpan={4}>{t("common.table.noData")}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-center">
                    <a href="javascript:void(0)" className="n-btn1 d-flex align-items-center justify-content-center" onClick={handleAdd}>
                      <i className="xi-plus-thin text-black"></i>
                    </a>
                  </div> */}

                  <div className="container-table mb-3" style={{minHeight: "645px", maxHeight: "645px", overflowY: "auto"}}>
                    {listProtocol.map((element: any, index: number) => (
                      <div key={element.id} className={"cursor-pointer fw-600 " + (protocolSlt.id === element.id ? "selected-text" : "")} onClick={() => handleSelectProtocol(element)}>
                        <span>{element.protNm}</span>
                      </div>
                    ))}
                    {listProtocol.length === 0 && (
                      <div className="text-center">
                        <span>{t("common.table.noData")}</span>
                      </div>
                    )}
                  </div>
                  <div className="d-flex justify-content-end">
                    <a href="javascript:void(0)" className="n-btn1 d-flex align-items-center justify-content-center" onClick={handleAdd}>
                      <i className="xi-plus-thin text-black"></i>
                    </a>
                  </div>
                </div>
                <div className="col-md-1"></div>
                {Object.keys(protocolSlt).length > 0 && (
                  <div className="col-md-7">
                    <div className="d-flex gap-3 align-items-center mb-2">
                      <div className="box-title">
                        {/* <h3 className="mb-sm-0 mb-0 flex-grow-1">{t("dcs0301.title.dialog.protocolDetail")}</h3> */}
                        <h3 className="mb-sm-0 mb-0 flex-grow-1">{protocolSlt.protNm}<i className="pi pi-pencil cursor-pointer mx-3 fs-5" onClick={() => editProtocol(protocolSlt)}></i></h3>
                      </div>

                      {/* <div className="d-flex gap-2">
                        <a href="javascript:void(0)" className="n-btn1 d-flex align-items-center justify-content-center" onClick={() => editProtocol(protocolSlt)}>
                          <i className="xi-pen text-black"></i>
                        </a>
                      </div> */}
                    </div>
                    <div className="row mb-3">
                      <div className="col-lg-4">
                        <img
                          src={protocolSlt.imgId ? process.env.REACT_APP_VIEW_IMAGE_URL + `/${protocolSlt.imgId}` : require("../../../../assets/images/no-img-avatar.png")}
                          alt="No image found"
                          onError={(e: any) => {
                            e.target.onerror = null;
                            e.target.src = require("../../../../assets/images/no-img-avatar.png");
                          }}
                          style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                      <div className="col-lg-8">
                        {/* <label className="fs-5 fw-600">{t("dcs0301.form.label.desc")}</label> */}
                        <div>
                          <span>{protocolSlt.description}</span>
                        </div>
                      </div>
                    </div>
                    <div className="tbl-st tbl-scroll-250 scroll-x">
                      <table>
                        <colgroup>
                          <col style={{ width: "5%" }} />
                          <col style={{ width: "25%" }} />
                          <col style={{ width: "25%" }} />
                          <col style={{ width: "25%" }} />
                          <col style={{ width: "20%" }} />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>{t("dcs0301.table.header.no")}</th>
                            <th>{t("dcs0301.table.header.version")}</th>
                            <th>{t("dcs0301.table.header.status")}</th>
                            <th>{t("dcs0301.table.header.createdDate")}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {listVersion.map((data: any, index: number) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{data.ver}</td>
                              <td>
                                <ViewActiveStatus value={data.status}></ViewActiveStatus>
                              </td>
                              <td>{moment(data.createdDt).format("MM/DD/YYYY")}</td>
                              <td>
                                <div className="action-button d-flex gap-2">
                                  <button className="custom-btn small-btn" onClick={() => editVersion(data)}>
                                    {t("dcs0201.btn.edit")}
                                  </button>
                                  {data.status === VariablesConstant.INACTIVE_STATUS_VAL && (
                                    <button className="custom-btn danger small-btn" onClick={() => deleteVersion(data)}>
                                      {t("dcs0201.btn.delete")}
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                          {(listVersion.length === 0 || Object.keys(protocolSlt).length === 0) && (
                            <tr className="text-center">
                              <td colSpan={5}>{t("common.table.noData")}</td>
                            </tr>
                          )}
                          {/* {Object.keys(protocolSlt).length !== 0 && (
                          <tr>
                            <td colSpan={5} className="text-center">
                              <a href="javascript:void(0)" className="n-btn1" onClick={() => addVersion()}>
                                <i className="xi-plus-thin text-black"></i>
                              </a>
                            </td>
                          </tr>
                        )} */}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex justify-content-center">
                      {/* {listVersion.length > 0 && <AppPagination page={versionSearch.page + 1} rows={versionSearch.size} onChange={changePage} count={totalVersionPage.current} />} */}
                      {Object.keys(protocolSlt).length !== 0 && (
                        <a href="javascript:void(0)" className="n-btn1 d-flex align-items-center justify-content-center" onClick={() => addVersion()}>
                          <i className="xi-plus-thin text-black"></i>
                        </a>
                      )}
                    </div>
                  </div>
                )}
                <div className="col-md-1"></div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* {openForm && <Dcs0301Form onSave={onSave} onClose={closeForm} data={data} />} */}
      {/* {viewDetailProtocol && <Dcs0301Detail onSave={onSave} onClose={closeForm} data={data} />} */}
    </>
  );
}
